export default {
  title: 'Twoja strona internetowa jest gotowa',
  body_one: 'Rezerwacje są nadal wyłączone dla {{count}} restauracji:',
  body_few: 'Rezerwacje są nadal wyłączone dla {{count}} restauracji:',
  body_many: 'Rezerwacje są nadal wyłączone dla {{count}} restauracji:',
  body_other: 'Rezerwacje są nadal wyłączone dla {{count}} restauracji:',
  reasons: {
    license_required: 'Wymaga planu Partner',
    notification_email_required:
      'Wymaga adresu e-mail do powiadomień o rezerwacjach. Można go podać przy włączaniu rezerwacji.',
    switched_off: 'Wyłączono w ustawieniach rezerwacji',
    activation_failed: 'Nie udało się włączyć. Spróbuj ponownie w ustawieniach rezerwacji.',
  },
  buttons: {
    open_settings: 'Otwórz ustawienia rezerwacji',
    continue: 'Przejdź do kreatora strony',
  },
};
